import React from 'react';
import { Repeat } from 'sushiweb/Icons';
import { Tooltip, CopyText } from '../../../../UiKit';
import { grey } from 'sushiweb/tokens/color';
import { WFHCall } from '../../../commons';
import { Eye, Headset } from 'lucide-react';
import { UserPrimaryNumberCallClickEvent } from '../../../../analytics/call-logging/events';

export const UserNumberV1 = ({
  number = 'xxxxxxxxxx',
  numberInfo = null,
  calledTo,
  isWFH = false,
  orderId = null,
  userId = null,
  isNewUser = false,
  unmaskNumber = () => {},
  regenerateNumber = () => {},
  hasAlternativeContact = false,
  cartId = null,
}) => {
  return (
    <div className='tw-flex tw-items-center tw-gap-3'>
      <Headset size={16} className='tw-text-grey-600' strokeWidth={2} />

      <Tooltip
        position='bottom'
        border={!hasAlternativeContact}
        title={
          <div className='tw-text-zinc-600 tw-font-regular'>
            {numberInfo ? (
              <CopyText
                orderId={orderId}
                title={numberInfo?.phone}
                masking={false}
                calledTo={calledTo}
                maskEverything={true}
              />
            ) : (
              <div className='masked tw-flex tw-items-center tw-leading-tight'>
                <span
                  className='tw-min-w-[11rem] tw-whitespace-nowrap tw-text-left'
                  data-dd-privacy='mask'
                >
                  {number}
                </span>
                <Eye
                  size={16}
                  strokeWidth={1.5}
                  className='tw-cursor-pointer tw-text-grey-400 hover:tw-text-grey-500 tw-transition-colors tw-ease-in-out tw-duration-200'
                  onClick={() => unmaskNumber(false)}
                  data-dd-action-name='Unmask Customer Number'
                />
              </div>
            )}
          </div>
        }
        fontWeight={'300'}
        label={hasAlternativeContact ? 'Sender Contact Number' : ''}
      />

      {numberInfo && numberInfo.show_reload_button && (
        <Tooltip
          position='bottom'
          title={
            <div
              className='pointer'
              onClick={() =>
                regenerateNumber(numberInfo.masked_number_popup, false)
              }
            >
              <Repeat size={18} color={grey.z500} />
            </div>
          }
          label='Renew Masked Number'
        />
      )}

      {isWFH ? (
        <WFHCall
          orderId={orderId}
          userId={userId}
          isNewUser={isNewUser}
          pos='top'
          isUser={true}
          calledTo={calledTo}
          isAltContact={false}
          altContactMissing={!hasAlternativeContact}
          sendJumboEvent={true}
          jumboEventFunc={UserPrimaryNumberCallClickEvent}
          JumboEventProperties={{
            user_number: numberInfo?.phone,
            called_to: calledTo,
            is_new_ui: true,
          }}
          cartId={cartId}
        />
      ) : null}
    </div>
  );
};
